/* eslint-disable camelcase */
import { FormikProps } from 'formik';

// Constants
import STATE_LIST from 'constants/states';

// Helpers
import { parseHTML } from './parseHTML';

export interface ResultsFieldsAlgoliaInterface {
  postcode: string;
  locale_names: any;
  suburb: string;
  city: any;
  administrative: string;
}

export interface ResultsFieldsInterface {
  postalCode: number;
  street: string;
  district: string;
  city: string;
  state: string;
}

export const handleResults = (
  resultsFields: ResultsFieldsInterface,
  formik: FormikProps<any>,
) => {
  const { postalCode, street, district, city, state } = resultsFields;

  if (postalCode) {
    formik.setFieldValue('address.cep', postalCode);
    // force the form to be validated
    setTimeout(() => formik.setFieldTouched('address.cep', true));
  }
  if (street) {
    formik.setFieldValue('address.street', street);
    setTimeout(() => formik.setFieldTouched('address.street', true));
  }
  if (district) {
    formik.setFieldValue('address.neigh', district);
    setTimeout(() => formik.setFieldTouched('address.neigh', true));
  }
  if (city) {
    formik.setFieldValue('address.city', city);
    setTimeout(() => formik.setFieldTouched('address.city', true));
  }
  if (state) {
    const stateAbbr = STATE_LIST.find((s) => s.name === parseHTML(state))
      ?.abbreviation;

    formik.setFieldValue('address.state', stateAbbr);
    setTimeout(() => formik.setFieldTouched('address.state', true));
  }
};

export const handleResultsAlgolia = (
  resultsFields: ResultsFieldsAlgoliaInterface,
  formik: FormikProps<any>,
) => {
  const {
    postcode,
    locale_names,
    suburb,
    city,
    administrative,
  } = resultsFields;

  if (postcode) {
    formik.setFieldValue('address.cep', postcode[0]);
    // force the form to be validated
    setTimeout(() => formik.setFieldTouched('address.cep', true));
  }
  if (locale_names) {
    formik.setFieldValue(
      'address.street',
      locale_names.default
        ? String(locale_names.default[0])
        : String(locale_names[0]),
    );
    setTimeout(() => formik.setFieldTouched('address.street', true));
  }
  if (suburb) {
    formik.setFieldValue('address.neigh', String(suburb));
    setTimeout(() => formik.setFieldTouched('address.neigh', true));
  }
  if (city) {
    formik.setFieldValue(
      'address.city',
      city.default ? String(city.default[0]) : String(city[0]),
    );
    setTimeout(() => formik.setFieldTouched('address.city', true));
  }
  if (Array.isArray(administrative) && administrative.length > 0) {
    const [state] = administrative;

    const stateAbbr = STATE_LIST.find((s) => s.name === parseHTML(state))
      ?.abbreviation;

    formik.setFieldValue('address.state', stateAbbr);
    setTimeout(() => formik.setFieldTouched('address.state', true));
  }
};
